export default __webpack_public_path__ + "static/media/no-page.7ea91173.svg";